<template>
  <div v-if="data[0].title" :class="_.notice">
    <div :class="_.label">
      <img :src="theme.icon" :class="_.icon" />
      <div :class="_.divider"></div>
    </div>
    <van-notice-bar :class="_.value" scrollable>
      {{ data[0].title }}
    </van-notice-bar>
  </div>
</template>

<script>
  import Vue from 'vue'

  export default Vue.extend({})
</script>

<style lang="scss" module="_">
  .notice {
    display: flex;
    align-items: center;
    border-radius: var(--border-radius);
    overflow: hidden;
    height: 44px;

    .label {
      flex-shrink: 0;
      padding-left: 8px;
      display: flex;
      align-items: center;

      .icon {
        width: 24px;
        height: 24px;
      }

      .divider {
        margin-left: 5px;
        width: 1px;
        height: 16px;
        background: #f7c2a5;
      }
    }

    .value {
      margin-left: 8px;
      flex-grow: 1;
      background-color: transparent;
      color: inherit;
      padding: 0;
      height: 20px;
      font-size: inherit;
      font-size: 14px;
      color: var(--color);
    }
  }
</style>
